var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.28666 15.8727L2.40604 16.7689C1.62283 16.9497 0.875 16.355 0.875 15.5511V3.11887C0.875 2.53697 1.27659 2.03206 1.84357 1.90111L6.28666 0.875V15.8727Z",
    stroke: "#2D4C5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29163 15.8727L11.7158 17.1225V2.1248L6.29163 0.875V15.8727Z",
    stroke: "#2D4C5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1252 14.875C17.1252 15.4569 16.7237 15.9618 16.1568 16.0928L11.7136 17.1189V2.12119L15.5942 1.22498C16.3775 1.0441 17.1252 1.63891 17.1252 2.44273V14.875Z",
    stroke: "#2D4C5D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMap;